import { jsx as _jsx } from "react/jsx-runtime";
import { Theme } from '@chakra-ui/react';
import { useTheme } from 'next-themes';
import { useCallback, useSyncExternalStore } from 'react';
const subscribeNever = () => () => { };
const snapshotHydrated = () => true;
const snapshotServer = () => false;
const useIsHydrated = () => useSyncExternalStore(subscribeNever, snapshotHydrated, snapshotServer);
export function useColorMode() {
    const { resolvedTheme, setTheme, forcedTheme } = useTheme();
    const isHydrated = useIsHydrated();
    const colorMode = (forcedTheme ??
        (isHydrated ? resolvedTheme : undefined) ??
        'light');
    const toggleColorMode = useCallback(() => {
        setTheme(colorMode === 'dark' ? 'light' : 'dark');
    }, [colorMode, setTheme]);
    return { colorMode, setColorMode: setTheme, toggleColorMode };
}
export function useColorModeValue(light, dark) {
    return useColorMode().colorMode === 'dark' ? dark : light;
}
export const DarkMode = ({ children }) => (_jsx(Theme, { appearance: "dark", hasBackground: false, display: "contents", color: undefined, colorPalette: undefined, children: children }));
export const LightMode = ({ children }) => (_jsx(Theme, { appearance: "light", hasBackground: false, display: "contents", color: undefined, colorPalette: undefined, children: children }));
